import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CVScore {
  cvId: number;
  applicantName: string;
  totalScore: number;
  breakdown: {
    technicalSkills: number;
    experience: number;
    education: number;
    leadership: number;
    communication: number;
  };
  strengths: string[];
  weaknesses: string[];
  recommendation: string;
  scoredAt?: string;
}

export interface ScoringResult {
  jobPosition: {
    id: number;
    title: string;
    description: string;
  };
  scores: CVScore[];
  summary: string;
  totalCVs: number;
  scoredCVs: number;
  scoredAt?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CVScoringService {
  private apiUrl = `${environment.apiUrl}/cv-scoring`;

  constructor(private http: HttpClient) { }

  /**
   * Score CVs for a job position
   */
  scoreJobPositionCVs(jobPositionId: number, description: string): Observable<{success: boolean, data: ScoringResult, message?: string}> {
    return this.http.post<{success: boolean, data: ScoringResult, message?: string}>(`${this.apiUrl}/${jobPositionId}/score`, {
      description
    });
  }

  /**
   * Get scoring results for a job position
   */
  getScoringResults(jobPositionId: number): Observable<{success: boolean, data: ScoringResult}> {
    return this.http.get<{success: boolean, data: ScoringResult}>(`${this.apiUrl}/${jobPositionId}/results`);
  }
}


